import Initials from './Initials.jsx';

export default Initials;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Initials/index.js